// extracted by mini-css-extract-plugin
export var drawerPaper = "_39-0";
export var itemCard = "_39-1";
export var itemImage = "_39-2";